<template>
  <div>
    <div class="row" style="height: 100vh; width: 100%;">
      <div class="col-md-8 p-0">
        <div style="background-color: white;  height: 100vh;">
          <div class="background d-flex flex-column" style="justify-content: start;">
            <div class="transbox">
              <div v-if="loading">
                <div class="text-center py-4 px-2">
                  <b-spinner class="align-middle mx-2"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </div>
              <div v-else class="d-flex flex-row px-5 py-2">
                <img :src="imageBasePath + companyLogoUrl" alt="" style="width: 15%;object-fit: contain"/>
                <p>{{ companyFullName }}</p>
              </div>
            </div>
            <div style="height: 30vh;"></div>
          </div>
        </div>

      </div>
      <div class="col-md-4 p-0 bg-white">
        <div class="px-5 py-4" style="background-color: white; height: 100vh; ">
                    <span v-if="!loading" class="d-flex flex-row align-items-center text-center"
                          style="justify-content: space-between; padding-inline: 60px;">
                        <img alt="" src="../assets/bdgovt.png" style="width: 35%; object-fit: contain;"/>
                        <img :src="imageBasePath + companyLogoUrl" alt="" style="width: 40%; object-fit: contain;"/>
                    </span>
          <div v-else>
            <b-spinner class="align-middle mx-2"></b-spinner>
          </div>
          <div style="height: 8vh;"></div>

          <div class="d-flex flex-column align-items-start">
            <div style="font-weight: 600; font-size: 24px;">Forgot your password?</div>
          </div>
          <div style="height: 6vh;"></div>
          <div v-if="ssoLoggingLoading">
            <div class="text-center text-primary my-2 px-2">
              <b-spinner class="align-middle mx-2"></b-spinner>
              <strong>Please wait...</strong>
            </div>
          </div>
          <div v-else class="d-flex flex-column">
            <RouterLink class="align-self-end mb-2 cursor-pointer" style="margin-inline: 40px;" to="/">
              Login
            </RouterLink>
            <div class="form-data">
              <div class="forms-inputs mb-4" style="margin-inline: 40px;">
                <span style="font-size: 14px;">USER ID</span>
                <input v-model="userId" :disabled="showOtp || showResetPassword" autocomplete="off"
                       class="form-control px-3"
                       style="height: 6vh;"
                       type="text"/>
              </div>

              <div style="height: 4vh;"></div>
              <div v-if="showOtp" class="mb-4 text-center">
                {{ otpPhoneMessage }}
              </div>
              <div v-if="showOtp" class="forms-inputs mb-4" style="margin-inline: 40px;">
                <span class="startColor requiredMark" style="font-size: 14px;">OTP *</span>
                <input id="name" v-model="otp" aria-describedby="phoneHelp" class="form-control px-3"
                       required style="height: 6vh;" width="100%"/>
              </div>
              <div v-if="showResetPassword" class="forms-inputs mb-4" style="margin-inline: 40px;">
                <span class="startColor requiredMark" style="font-size: 14px;">New Password *</span>
                <input v-model="password" :disabled="showOtpModal" :type="showPassword ? 'text' : 'password'"
                       autocomplete="off"
                       class="px-3" style="height: 6vh;" v-bind:class="{
                                        'form-control': true,
                                        'is-invalid':
                                            !validPassword(password) && passwordBlurred,
                                    }" v-on:blur="passwordBlurred = true"/>
                <div v-if="showPassword" class="password-show" role="button" @click="toggleShow">
                  <i class="fas fa-eye" style="color: grey;"></i>
                </div>
                <div v-else class="password-show" role="button" @click="toggleShow">
                  <i class="fas fa-eye-slash" style="color: grey;"></i>
                </div>
              </div>
              <div class="mb-3 d-flex flex-column justify-content-center">
                <button v-if="loading" class="btn btn-dark custom-login-btns" disabled type="button">
                  <span aria-hidden="true" class="spinner-grow spinner-grow-sm" role="status"></span>
                  <span class="sr-only">Loading...</span>
                </button>
                <button v-else-if="showOtp" class="btn btn-dark custom-login-btns"
                        type="submit" @click="validateOtp">
                  Submit
                </button>
                <button v-else-if="showResetPassword" class="btn btn-dark custom-login-btns"
                        type="submit" @click="changePassword">
                  Change Password
                </button>
                <button v-else class="btn btn-dark custom-login-btns"
                        type="submit" @click="sendOtp">
                  Send OTP
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {notify} from "@kyvg/vue3-notification";
import systemSettingsService from "@/services/system-settings.service";
import Config from '@/config/index';
import authService from "@/services/auth.service";

export default {
  name: "LoginPage",
  data() {
    return {
      tempUserData: {},
      imageBasePath: null,
      passwordBlurred: false,
      useLoginOtp: true,
      showPassword: false,
      user: {
        userId: "",
        password: "",
        otp: "",
      },
      loading: false,
      year: new Date().getFullYear(),
      companyName: "IDRA",
      companyDescription: "Insurance Development and Regulatory Authority",
      companyLogoUrl: null,
      termsAgreed: true,
      companyFullName: "",
      ssoLoggingLoading: false,
      currentDate: new Date().toISOString().split('T')[0],
      showOtpModal: false,
      otpPhoneMessage: null,
      userId: null,
      otp: null,
      isOtpValidated: false,
      showOtp: false,
      showResetPassword: false,
      password: '',
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  async created() {
    this.imageBasePath = Config.apiFileBasePath;
    await this.getSystemSettings();
  },
  methods: {
    validPassword: function (password) {
      if (password.length > 7) {
        return true;
      }
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    async sendOtp() {
      try {
        this.loading = true
        const otpPayload = {
          user_id: this.userId
        }
        this.loading = false
        const otpValidationResponse = await authService.getResetOtp(otpPayload)
        if (otpValidationResponse && otpValidationResponse.status) {
          notify({
            type: "success",
            title: "OTP",
            text: otpValidationResponse.message,
          });
          this.otpPhoneMessage = otpValidationResponse.message;
          this.showOtp = true;
        } else {
          notify({
            type: "error",
            title: "OTP",
            text: otpValidationResponse.message,
          });
        }

      } catch (e) {
        this.loading = false
        console.log(e)
      }
    },

    async validateOtp() {
      try {
        this.loading = true
        const otpPayload = {
          otp: this.otp,
          user_id: this.userId
        }
        this.loading = false
        const otpValidationResponse = await authService.validateOtp(otpPayload)
        if (otpValidationResponse && otpValidationResponse.status) {
          notify({
            type: "success",
            title: "OTP",
            text: otpValidationResponse.message,
          });
          this.otpPhoneMessage = null;
          this.showResetPassword = true;
          this.showOtp = false;
        } else {
          notify({
            type: "error",
            title: "OTP",
            text: otpValidationResponse.message,
          });
        }

      } catch (e) {
        this.loading = false
        console.log(e)
      }
    },

    async changePassword() {
      try {
        this.loading = true
        const passwordPayload = {
          password: this.password,
          loginId: this.userId
        }
        this.loading = false
        const response = await authService.resetPassword(passwordPayload)
        if (response && response.status) {
          await this.$router.push('/');

          notify({
            type: "success",
            title: "Change Password",
            text: response.message,
          });
          this.otpPhoneMessage = null;
          this.showResetPassword = true;
          this.showOtp = false;
        } else {
          notify({
            type: "error",
            title: "Change Password",
            text: response.message,
          });
        }

      } catch (e) {
        this.loading = false
        console.log(e)
      }
    },

    async getSystemSettings() {
      this.loading = true;
      let response;
      try {
        response = await systemSettingsService.getSystemSettingsWithoutAuth();
        if (response.data) {
          const adminCmsLogoObj = response.data.find(item => item.system_key === "login_page_logo");
          this.companyLogoUrl = adminCmsLogoObj ? adminCmsLogoObj.value : null;
          const company_short_name_obj = response.data.find(item => item.system_key === "company_short_name");
          this.companyName = company_short_name_obj ? company_short_name_obj.value : null;
          const company_desc_obj = response.data.find(item => item.system_key === "company_description");
          this.companyDescription = company_desc_obj ? company_desc_obj.value : null;
          const company_name_obj = response.data.find(item => item.system_key === "company_name");
          this.companyFullName = company_name_obj ? company_name_obj.value : null;
          const text_editor_token_obj = response.data.find(item => item.system_key === "text_editor_token");
          const token = text_editor_token_obj ? text_editor_token_obj.value : null;
          const carrer_api_url_obj = response.data.find(item => item.system_key === "carrer_api_url");
          const carrer_api_url = carrer_api_url_obj ? carrer_api_url_obj.value : null;

          const useLoginOtpObject = response.data.find(item => item.system_key === "use_login_otp");
          this.useLoginOtp = useLoginOtpObject ? useLoginOtpObject.value === 'Y' : false;
          localStorage.setItem('text_editor_token', token);
          localStorage.setItem('carrer_api_url', carrer_api_url);
        } else {
          notify({
            type: 'error',
            title: 'Error',
            text: "Something went wrong",
          });
        }
      } catch (error) {
        this.loading = false;
        notify({
          type: 'error',
          title: 'Error',
          text: error,
        });
      }
      this.loading = false;
    },


  },
};
</script>

<style>
.forms-inputs {
  position: relative;
}

.forms-inputs span {
  position: absolute;
  top: -18px;
  left: 10px;
  background-color: #fff;
  padding: 5px 10px;
  font-size: 15px;
  color: #313242;
}

.forms-inputs input {
  height: 50px;
  border: 2px solid #eee;
}

.forms-inputs input:focus {
  box-shadow: none;
  outline: none;
  border: 2px solid #000;
}

.btn {
  height: 50px;
}

div.background {
  background: linear-gradient(rgba(0, 0, 0, 0.527), rgba(0, 0, 0, 0.5)), url(../assets/insurance_pen.jpg);
  border: 1px solid black;
  height: 100%;
  width: 100%;
  /* border-top-right-radius: 10px;
  border-bottom-right-radius: 10px; */
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}

div.transbox {
  margin: 30px;
  margin-top: 10%;
  background-color: #E7E7E7;
  border: 1px solid black;
  opacity: 0.8;
  text-align: center;
}

div.transbox p {
  margin: 5%;
  font-weight: bold;
  color: rgb(0, 0, 0);
  font-size: 25px;
  opacity: 1;
}

.custom-login-btns {
  height: 6vh !important;
  width: 50%;
  align-self: center;
}
</style>
